import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_CHAT_HISTORY = gql`
    query OnboardingChatHistory($chatHistoryRequest: ChatHistoryRequestDto!) {
        onboardingChatHistory(chatHistoryRequest: $chatHistoryRequest) {
            messages {
                uuid
                candidateUuid
                senderName
                adminSender
                content
                modified
                editable
                createdAt
                adminReadAt
                candidateReadAt
            }
            hasNext
        }
    }
`;

const useOnboardingChatHistory = (candidateUuid, sliceNumber) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_CHAT_HISTORY, {
        variables: {
            chatHistoryRequest: {
                candidateUuid,
                sliceNumber,
            },
        },
        skip: !candidateUuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingChatHistory,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingChatHistory;
